import React, { Component } from 'react';
import {connect} from 'react-redux';
import { getSecSubQuestionList, softDeleteSecSubQuestion} from '../../actions/demographics';
import DemographicsSecondSubQuestionList from '../../components/demographics/secSubQuestionList';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './style.css';

class DemographicsSecondSubQuestions extends Component {
  constructor(props){
    super(props)
    this.queryString = window.location.href;

    if (this.queryString !== "") {
        this.catId = this.queryString.split("/&c:")[1].split("/")[0];
        this.quesId = this.queryString.split("/&q:")[1].split("/")[0];
        this.subQuesId = this.queryString.split("/&sq:")[1].split("/")[0];
    }

    this.state={
      catId : this.catId,
      quesId : this.quesId,
      subQuesId : this.subQuesId,
      editOptionsData : '',
      editOptions: false
    };
      this.addSecSubQuestion = this.addSecSubQuestion.bind(this);
      this.softDeleteSecSubQuestion = this.softDeleteSecSubQuestion.bind(this);
      this.editSecSubQuestion = this.editSecSubQuestion.bind(this);
  }

  
  componentWillMount() {
    this.props.dispatch( getSecSubQuestionList( this.state.catId, this.state.quesId, this.state.subQuesId));
  }

  addSecSubQuestion(){
    this.props.history.push('/demoAddSecSubQuestion/&c:'+this.state.catId+'/&q:' + this.state.quesId +'/&sq:' + this.state.subQuesId );
  }

  softDeleteSecSubQuestion(data){
    this.props.dispatch(softDeleteSecSubQuestion(data));
  }

  editSecSubQuestion(data){
    this.props.history.push('/demoUpdateSecSubQuestion/&ssq:'+data._id);
  }


  render(){
    let showDemographicsSubQuestionView = <DemographicsSecondSubQuestionList
    demoGraphicsSecSubQuesOptionsListSuccess = {this.props.demoGraphicsSecSubQuesOptionsListSuccess}
    demoGraphicsSecSubQuesOptionsListData = {this.props.demoGraphicsSecSubQuesOptionsListData}
    addSecSubQuestion = {this.addSecSubQuestion}
    softDeleteSecSubQuestion ={this.softDeleteSecSubQuestion}
    editSecSubQuestion = {this.editSecSubQuestion}
    />
      
    return (
        <div> 
             {showDemographicsSubQuestionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsSecSubQuesOptionsListSuccess   :     state.demographics.demoGraphicsSecSubQuesOptionsListSuccess,
    demoGraphicsSecSubQuesOptionsListData      :     state.demographics.demoGraphicsSecSubQuesOptionsListData
  }
}

export default connect(mapStateToProps)(DemographicsSecondSubQuestions);



// WEBPACK FOOTER //
// ./src/pages/demographics/demoSecSubquestion.js